"use client";

import { useEffect } from "react";
import { BaseErrorPage } from "@repo/utils/components/BaseErrorPage";
import * as Sentry from "@sentry/nextjs";

export default function Error({
  error,
  reset: _reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
    console.error(error);
  }, [error]);
  return <BaseErrorPage error={error} />;
}
